// Show the calendar data

function showCalendarData(start, end) {
  // Wrapper to build HTML in
  var wrapper = $('#panel-content-schedule');

  // Rest HTML
  wrapper.html('');

  // Build calendar node tree with only selected options
  const calendarDataFiltered = filterCalendarData(calendarData, start, end);

  var container;

  $.each(calendarDataFiltered, function (name, data) {
    if (!container) {
      container = $('<div class="calendar-tree__container"/>');
      container.appendTo(wrapper);
    }

    addNodeToggler(name, data, container, viewer, true, true);
  });

  // Add empty notice
  if (!$('.calendar-tree__container').length) {
    wrapper.append(
      $('<div class="panel__empty"/>').html(
        __('panelCalendarNoTasksMessage')
      )
    );
    $('.calendar-panel__wrapper').removeClass('calendar-tree-active');
  } else {
    $('.calendar-panel__wrapper').addClass('calendar-tree-active');
  }
}

// Filter calendarData by date

function filterCalendarData(data, start, end) {
  const startDate = getParsedDateInt(start);
  const endDate = getParsedDateInt(end);

  let calendarDataFiltered = {};

  $.each(data, function (index1, itemLevel1) {
    if (itemLevel1.children) {
      $.each(itemLevel1.children, function (index2, itemLevel2) {
        if (itemLevel2.children) {
          $.each(itemLevel2.children, function (index3, itemLevel3) {
            const dataStartDate = getParsedDateInt(itemLevel3.start);
            const dataEndDate = getParsedDateInt(itemLevel3.end);

            if (
              (dataStartDate >= startDate && dataStartDate <= endDate) ||
              (dataStartDate <= startDate && dataEndDate >= endDate) ||
              (dataEndDate >= startDate && dataEndDate <= endDate) ||
              (dataStartDate >= startDate && dataEndDate <= endDate)
            ) {
              // Level 1
              if (!calendarDataFiltered[index1]) {
                calendarDataFiltered[index1] = {
                  start: itemLevel1.start,
                  startIs: itemLevel1.startIs,
                  startShould: itemLevel1.startShould,
                  end: itemLevel1.end,
                  endIs: itemLevel1.endIs,
                  endShould: itemLevel1.endShould,
                  data: itemLevel1.data,
                  ids: [],
                  children: {}
                };
              }
              $.merge(calendarDataFiltered[index1].ids, itemLevel3.ids);

              // Level 2
              if (!calendarDataFiltered[index1].children[index2]) {
                calendarDataFiltered[index1].children[index2] = {
                  start: itemLevel2.start,
                  startIs: itemLevel2.startIs,
                  startShould: itemLevel2.startShould,
                  end: itemLevel2.end,
                  endIs: itemLevel2.endIs,
                  endShould: itemLevel2.endShould,
                  data: itemLevel2.data,
                  ids: [],
                  children: {}
                };
              }
              $.merge(
                calendarDataFiltered[index1].children[index2].ids,
                itemLevel3.ids
              );

              // Level 3
              if (
                !calendarDataFiltered[index1].children[index2].children[index3]
              ) {
                calendarDataFiltered[index1].children[index2].children[
                  index3
                ] = {
                  start: itemLevel3.start,
                  startIs: itemLevel3.startIs,
                  startShould: itemLevel3.startShould,
                  end: itemLevel3.end,
                  endIs: itemLevel3.endIs,
                  endShould: itemLevel3.endShould,
                  data: itemLevel3.data,
                  ids: [],
                  children: {}
                };
              }
              $.merge(
                calendarDataFiltered[index1].children[index2].children[index3]
                  .ids,
                itemLevel3.ids
              );
            }
          });
        }
      });
    }
  });

  return calendarDataFiltered;
}

// Get a parsed date

function getParsedDate(date) {
  var monthsDE = getAbbrMonthNamesDE();
  var monthsEN = getAbbrMonthNamesEN();

  var dateSplit = date.split(' ');
  if (dateSplit[1] && dateSplit[2] && dateSplit[3] && dateSplit[4]) {
    var time = dateSplit[3].split(':');
    var month =
      monthsEN.indexOf(dateSplit[2]) > -1
        ? monthsEN.indexOf(dateSplit[2])
        : monthsDE.indexOf(dateSplit[2]);

    var parsedDate = new Date(
      dateSplit[4],
      month,
      dateSplit[1].replace('.', ''),
      time[0],
      time[1],
      time[2]
    );
  } else {
    parsedDate = new Date(date);
  }

  return parsedDate;
}

function getParsedDateInt(date) {
  var dateObj = new Date(date);
  return parseInt(
    dateObj.getFullYear() +
      ('0' + (dateObj.getMonth() + 1)).slice(-2) +
      '' +
      ('0' + dateObj.getDate()).slice(-2)
  );
}

// Get date range

function getDateRange(startDate, endDate) {
  var months = getAbbrMonthNamesEN();

  var date = '';
  date += startDate.getDate() + '. ';
  date += months[startDate.getMonth()] + ' ';
  date += ('0' + startDate.getHours()).substr(-2) + ':';
  date += ('0' + startDate.getMinutes()).substr(-2);
  date += ' &nbsp;–&nbsp; ';
  date += endDate.getDate() + '. ';
  date += months[endDate.getMonth()] + ' ';
  date += ('0' + endDate.getHours()).substr(-2) + ':';
  date += ('0' + endDate.getMinutes()).substr(-2);

  return date;
}

// Get short date from date

function getShortParsedDateFromIsoDate(date) {
  var dateArr = date.split('-');
  if (dateArr.length == 3) {
    return dateArr[2] + '.' + dateArr[1] + '.' + dateArr[0];
  }
  return date;
}

// Get the difference in days from two iso dates

function getDayDifferenceFromIsoDate(date1, date2) {
  var dateObj1 = new Date(date1);
  var dateObj2 = new Date(date2);

  var Difference_In_Time = dateObj1.getTime() - dateObj2.getTime();
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

  return Difference_In_Days;
}
